import React from 'react';
import { BaasicTabsWrapperTemplate } from 'themes/components';
import PropTypes from 'prop-types';

function BaasicTabsWrapper(props) {
	return <BaasicTabsWrapperTemplate {...props} />;
}

BaasicTabsWrapper.propTypes = {	
	field: PropTypes.object,
	className: PropTypes.string,
	selectedTabClassName: PropTypes.string,
	value: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.array]),
	defaultFocus: PropTypes.bool,
	defaultIndex: PropTypes.number,
	direction: PropTypes.string,
	disabledTabClassName: PropTypes.string,
	onSelect: PropTypes.func,
	selectedIndex: PropTypes.number,
	placeholder: PropTypes.string,
};

export default BaasicTabsWrapper;



// WEBPACK FOOTER //
// ./src/core/components/tabs/BaasicTabsWrapper.jsx